import tinycolor from 'tinycolor2';
import { toRefs, inject, computed } from 'vue';
import { useButton } from './component-lib.esm.js';
import CircularLoader from '../circular-loader/component-lib.esm.js';
import { colors } from '../../styles/component-lib.esm.js';
import { useTheme } from '../../compositions/component-lib.esm3.js';
import { getThemeColor, getTextColor } from '../../styles/theme/component-lib.esm.js';

//
const ButtonProps = {
  component: {
    type: String,
    default: 'button'
  },
  size: {
    type: String,
    default: 'medium'
  },
  variant: {
    type: String,
    default: null
  },
  value: {
    type: [String, Number],
    default: null
  },
  color: {
    type: String,
    default: 'primary'
  },
  loading: Boolean,
  disabled: Boolean,
  block: Boolean,
  circular: Boolean
};
var script = {
  components: {
    CircularLoader
  },
  name: 'Button',
  props: ButtonProps,
  setup(props, _ref) {
    let {
      attrs,
      emit
    } = _ref;
    const {
      component,
      color,
      variant,
      disabled,
      value
    } = toRefs(props);
    const theme = useTheme();
    const {
      buttonTag,
      buttonType
    } = useButton({
      component,
      ...attrs
    });
    const {
      isInGroup,
      selected,
      onChange
    } = inject('button-group', {
      isInGroup: false,
      selected: null
    });
    const isActive = computed(() => {
      if (!isInGroup) return false;
      return selected.value === value.value;
    });
    const themeColor = computed(() => {
      return getThemeColor(color.value, theme.value);
    });
    const textColor = computed(() => {
      return getTextColor(color.value, theme.value);
    });
    const classes = computed(() => {
      return {
        [`v-button--${props.size}`]: true,
        [`v-button--${props.variant}`]: props.variant !== null,
        'v-button--active': isActive.value,
        'v-button--loading': props.loading,
        'v-button--block': props.block,
        'v-button--circular': props.circular
      };
    });
    const styles = computed(() => {
      let disabledVars = {};
      let colorsVars = {};
      if (disabled.value) {
        disabledVars = {
          '--c-disabled-color': colors.blackLight,
          '--c-disabled-bg-color': colors.gray
        };
      }
      const activeColor = tinycolor(themeColor.value);
      if (variant.value === 'flat') {
        colorsVars = {
          '--c-bg-color': 'transparent',
          '--c-bg-color-active': activeColor.setAlpha(0.1).toRgbString(),
          '--c-color': themeColor.value
        };
      } else {
        colorsVars = {
          '--c-bg-color': themeColor.value,
          '--c-bg-color-active': activeColor.isLight() ? activeColor.darken() : activeColor.lighten(),
          '--c-color': textColor.value
        };
      }
      if (variant.value === 'hard-shadow') {
        colorsVars = {
          ...colorsVars,
          '--c-shadow-color': tinycolor(themeColor.value).darken(10).toRgbString()
        };
      }
      return {
        ...colorsVars,
        ...disabledVars
      };
    });
    function handleClick(e) {
      if (isInGroup) onChange(value.value);
      emit('click', e);
    }
    return {
      isActive,
      buttonType,
      buttonTag,
      classes,
      styles,
      handleClick
    };
  }
};
export { ButtonProps, script as default };